import axios from '@axios'

export default {
    namespaced: true,
    state: {
        personalJer: [],
        seccion: [],
        organigrama: [],
        depCo: [],
        tipoAdmPro: [],
        subdep: [],
        divisionCo: [],
        cargoCo: [],
        subCargo: [],
        colaborador: [],
    },
    getters: {
        getSeccion(state){
            return state.seccion
        },

        getPersonalJer(state) {
            return state.personalJer
        },

        getOrganigrama(state) {
            return state.organigrama
        },

        getDepCo(state){
            return state.depCo
        },

        getTipoAdmPro(state){
            return state.tipoAdmPro
        },

        getSubDep(state){
            return state.subdep
        },

        getDivisionCo(state){
            return state.divisionCo
        },

        getCargoCo(state){
            return state.cargoCo
        },
        
        getSubCargo(state){
            return state.subCargo
        },

        getColaborador(state){
            return state.colaborador
        },
    },
    mutations: {
        SET_SECCION(state, seccion){
            state.seccion = seccion
        },

        SET_PERSONAL_JER(state, personalJer) {
            state.personalJer = personalJer
        },

        SET_ORGANIGRAMA(state, organigrama) {
            state.organigrama = organigrama
        },

        SET_DEP_CO(state, depCo){
            state.depCo = depCo
        },

        SET_TIPO_ADM_PRO(state, tipoAdmPro){
            state.tipoAdmPro = tipoAdmPro
        },

        SET_SUB_DEP(state, subdep){
            state.subdep = subdep
        },

        SET_DIVISION_CO(state, divisionCo){
            state.divisionCo = divisionCo
        },

        SET_CARGO_CO(state, cargoCo){
            state.cargoCo = cargoCo
        },

        SET_SUBCARGO(state, subCargo){
            state.subCargo = subCargo
        },

        SET_COLABORADOR(state, colaborador){
            state.colaborador = colaborador
        }
    },
    actions: {

        postEditarColaboradorCo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/costos/editarColaborador', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        
        fetchDepCo({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/depCostos/')
                    .then((response) => {
                        commit('SET_DEP_CO', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchTipoAdmPro({commit}){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/tipoAdmPro/')
                    .then((response)=>{
                        commit('SET_TIPO_ADM_PRO', response.data)
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchSubDep({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/subDep/'+co_departamento)
                    .then((response) => {
                        commit('SET_SUB_DEP', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchDivisionCo({commit}){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/divisionCo/')
                    .then((response)=>{
                        commit('SET_DIVISION_CO', response.data)
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchCargoCo({commit}){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/cargoCo/')
                    .then((response)=>{
                        commit('SET_CARGO_CO', response.data)
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchSubCargo({ commit }, co_cargo) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/subCargo/'+co_cargo)
                    .then((response) => {
                        commit('SET_SUBCARGO', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchColaborador({commit}){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/colaborador/')
                    .then((response)=>{
                        commit('SET_COLABORADOR', response.data)
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchVerificarColabExist({commit}, cedula){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/verificarColabExis/'+cedula)
                    .then((response)=>{
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchVerificarColabDatos({commit}, cedula){
            return new Promise((resolve, reject)=>{
                axios.get('/api/auth/costos/verificarColabDatos/'+cedula)
                    .then((response)=>{
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },

        fetchConsultarSeccionesJer({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/rrhh/consultarSeccionesJer/', {params: data})
                    .then((response) => {
                        commit('SET_SECCIONES_JER', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchConsultarPersonalJer({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/personalJerarquia/', {params: data})
                    .then((response) => {
                        commit('SET_PERSONAL_JER', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchSeccion({ commit }, co_jerarquia) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/seccion/'+co_jerarquia)
                    .then((response) => {
                        commit('SET_SECCION', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchOrganigrama({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/costos/organigrama/')
                    .then((response) => {
                        commit('SET_ORGANIGRAMA', response.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

    },
}